const PROGRESS_OPENED_KEY = 'ataric_lastOpenedProgressWeek';

/** Período do relatório de progresso: 7 dias (semana ISO: segunda a domingo). */
export function getISOWeek(date: Date): string {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  const yearStart = new Date(d.getFullYear(), 0, 1);
  const weekNo = Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
  return `${d.getFullYear()}-W${String(weekNo).padStart(2, '0')}`;
}

/**
 * Indica se há relatório novo (semana atual ainda não aberta pelo usuário).
 * Relatórios são atualizados a cada 7 dias; vale para NoProgress, EarlyProgress e Progress completo.
 */
export function hasNewProgressReport(): boolean {
  try {
    const current = getISOWeek(new Date());
    const last = localStorage.getItem(PROGRESS_OPENED_KEY);
    return last !== current;
  } catch {
    return true;
  }
}

/**
 * Marca que o usuário abriu a tela de progresso nesta semana.
 * Chamado ao entrar em /progresso (qualquer variante: NoProgress, EarlyProgress ou Progress).
 */
export function markProgressOpened(): void {
  try {
    localStorage.setItem(PROGRESS_OPENED_KEY, getISOWeek(new Date()));
  } catch {}
}
